import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, Clock3 } from "lucide-react";
import { resolvePaymentOrder } from "../../entities/order/paymentReturn";
import { showToast } from "../../shared/ui/toast";

export default function PaymentReturnPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const traceNo = searchParams.get("out_trade_no") || searchParams.get("payment_no") || "";

  useEffect(() => {
    const orderId = resolvePaymentOrder(traceNo);
    const timer = window.setTimeout(() => {
      if (orderId) {
        navigate(`/orders/${orderId}?payment=return`, { replace: true });
        return;
      }
      showToast("支付已返回，请在订单列表中确认支付状态");
      navigate("/orders?view=sent", { replace: true });
    }, 900);
    return () => window.clearTimeout(timer);
  }, [navigate, traceNo]);

  return (
    <section className="page-container narrow-page payment-return-page">
      <div className="payment-return-card">
        <span className="payment-return-icon">
          {traceNo ? <CheckCircle2 size={30} /> : <Clock3 size={30} />}
        </span>
        <h1>支付结果确认中</h1>
        <p>正在返回订单详情页，请稍候查看最终支付状态。</p>
      </div>
    </section>
  );
}
